import get from 'lodash/get';
import { useCallback } from 'react';
import { useSelector } from 'react-redux';

import { selectInsuranceRelationList } from '../../redux/data/selectors';

const useInsuranceRelationOptions = () => {
  const insuranceRelationList = useSelector(selectInsuranceRelationList);

  const insuranceRelationOptions = insuranceRelationList.reduce(
    (acc, { id, name, enabled }) => {
      if (enabled) {
        acc.push({
          value: id,
          label: name,
        });
      }

      return acc;
    },
    [],
  );

  const hideInsuranceRelationFieldOrInfo = !insuranceRelationOptions.length;

  const getInsuranceRelationTitleById = useCallback(
    id => {
      const matchedInsuranceRelation = insuranceRelationOptions.find(
        item =>
          item.value === id ||
          (typeof id === 'string' && id && item.value === Number(id)),
      );

      return get(matchedInsuranceRelation, 'label', null);
    },
    [insuranceRelationOptions],
  );

  return {
    hideInsuranceRelationFieldOrInfo,
    getInsuranceRelationTitleById,
    insuranceRelationOptions,
  };
};

export default useInsuranceRelationOptions;



// WEBPACK FOOTER //
// ./src/hooks/selectOptions/useInsuranceRelationOptions.js